export default __webpack_public_path__ + "af7c0dd2f56c49f7194dc9c77b59a8af.jpg";